import type { Setup } from "features/setups/types";
import { BaseSetupValue, type IntValue, type ISetupValue } from "../types";

export class IntSetupValue extends BaseSetupValue<IntValue> implements ISetupValue<IntValue> {
    public deserialize(setupValue: Setup<string>['setupValue']): IntValue {
       return Number(setupValue);
    }

    public serialize() {
        return String(this.value);
    }
}
